import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ITableConfig } from '../../../../../../../projects/common/src/app/interfaces/table/table-config';
import { ITableDataParams } from '../../../../../../../projects/common/src/app/interfaces/table/table-data-params';
import { ITableHeaderParams } from '../../../../../../../projects/common/src/app/interfaces/table/table-header-params';
import { TableConfigService } from '../../../../../../../projects/common/src/app/services/table/table-config.service';
import { ReportOperationalDisciplineService } from '../../../services/report-operational-discipline.service';
import { Subscription } from 'rxjs';
import { AuthenticationService } from 'projects/authentication/src/app/services';

@Component({
  selector: 'app-report-operational-discipline-modal',
  templateUrl: './report-operational-discipline-modal.component.html',
  styleUrls: ['./report-operational-discipline-modal.component.scss'],
})
export class ReportOperationalDisciplineModalComponent implements OnInit, OnDestroy {
  @Input() public params: any;
  @Input() public shiftName: string;
  @Input() public machineName: string;
  public tableConfig: ITableConfig;
  public logoutSub: Subscription;

  constructor(
    private tableService: TableConfigService,
    private _operationalDisciplineService: ReportOperationalDisciplineService,
    public activeModal: NgbActiveModal,
    private authService: AuthenticationService,
  ) {}

  ngOnInit(): void {
    this.getDetailDiscipline(this.params);
    this.logoutSub = this.authService.tokenExpired$.subscribe(() => {
      this.activeModal.dismiss('logout');
    });
  }

  ngOnDestroy(): void {
    // Unsubscribe to avoid memory leaks
    if (this.logoutSub) {
      this.logoutSub.unsubscribe();
    }
  }

  public getDetailDiscipline(params: any) {
    this._operationalDisciplineService.getDetailReportOperationalDiscipline(params).subscribe((response) => {
      this.fillTableDetail(response.data);
    });
  }

  public fillTableDetail(tableData: any): void {
    const headerParams: ITableHeaderParams = {
      data: tableData,
      excludeColumns: ['operatorId', 'shiftId', 'shiftName', 'machineId', 'machineName', 'startDate'],
      replaceColumnName: [
        { prevName: 'loginAt', newName: 'start-session' },
        { prevName: 'logoutAt', newName: 'close-session' },
        { prevName: 'operatorFullName', newName: 'operator' },
        { prevName: 'lastLocation', newName: 'last_location' },
        { prevName: 'statusOperational', newName: 'operative' },
        { prevName: 'statusDelay', newName: 'delay' },
        { prevName: 'statusReserve', newName: 'reserve' },
        { prevName: 'statusOutOfService', newName: 'out_of_service_short' },
        { prevName: 'productionCount', newName: 'drillings' },
        { prevName: 'productionTotal', newName: 'drillings_mts_short' },
      ],
    };
    const datasetParams: ITableDataParams = {
      tableData,
      excludeColumns: ['operatorId', 'shiftId', 'shiftName', 'machineId', 'machineName', 'startDate'],
      dateConfig: [
        { field: 'loginAt', format: 'full-time' },
        { field: 'logoutAt', format: 'full-time' },
      ],
    };

    const header = this.tableService.setHeaderConfig(headerParams);
    const dataset = this.tableService.setDatasetConfig(datasetParams);
    this.tableConfig = { header, dataset };
  }
}
